import * as yup from "yup";

export const validation = yup.object().shape({
  firstname: yup.string().required("Este campo es obligatorio"),
  lastname: yup.string().required("Este campo es obligatorio"),
  dni: yup
    .number()
    .typeError("Ingrese un N° de DNI")
    .min(100000, "Debe ser un DNI válido")
    .max(99999999, "El DNI es demasiado largo")
    .required("Este campo es obligatorio"),
    cuit: yup
    .number()
    .typeError("Ingrese un n° de CUIT sin guiones")
    .min(100000000, "Debe ser un CUIT válido")
    .max(99999999999, "El CUIT es demasiado largo")
    .required("Este campo es obligatorio"),
  address: yup.string().required("Este campo es obligatorio"),
  email: yup
    .string()
    .email("debe ser un domicilio electrónico válido")
    .required("Este campo es obligatorio"),
  domain: yup.string().required("Este campo es obligatorio"),
});

export const validationTaxpayer = yup.object().shape({
  razon_social: yup.string().required("Este campo es obligatorio"),
  nro_doc: yup
    .number()
    .typeError("Ingrese un Número de Documento")
    .required("Este campo es obligatorio"),
  telefonos: yup.string().required("Este campo es obligatorio"),
  nro: yup
    .number()
    .typeError("Ingrese Altura")
    .required("Este campo es obligatorio"),
  cp: yup
    .number()
    .typeError("Ingrese Código Postal")
    .required("Este campo es obligatorio"),
  cod_calle: yup.string().required("Este campo es obligatorio"),
  codbarrio: yup.string().required("Este campo es obligatorio"),
  tp_persona: yup.string().required("Este campo es obligatorio"),
  tp_iva: yup.string().required("Este campo es obligatorio"),
  tipo_doc: yup.string().required("Este campo es obligatorio"),
});
